import { getBookByIsbn } from "../books/selectors";
import { getAsset, isActivating } from "../bridge/selectors";
import {
  isSearchBookContentSearching,
  isFinishedSearchingBookContent
} from "../search/selectors";

/**
 * @deprecated
 * This might not return what you expect. It should check the books reducer array of isbns that gets set from get book list.
 * However, the feature that uses this is about to be ripped out, so we'll just delete this at that time rather than fixing it
 */
export function isLicensed(state, isbn) {
  const licensedBook = getBookByIsbn(state, isbn);
  const bridgeBook = getAsset(state, isbn);
  return licensedBook || (bridgeBook && bridgeBook.active);
}

// Well, searching content or doing the related activation
export function isSearchingContent(state, isbn) {
  return isActivating(state, isbn) || isSearchBookContentSearching(state, isbn);
}

export function hasCompletedSearch(state, isbn) {
  return (
    !isActivating(state, isbn) && isFinishedSearchingBookContent(state, isbn)
  );
}
